import React, { useState } from 'react';
import LineEditorTable from './lineEditorTable';

const LineEditorTables = ({
  upfrontGroups, recurringGroups, upfrontItems, recurringItems, mode,
  onUpfrontGroupMoved, onUpfrontItemMoved, onAddUpfrontGroup, onDeleteUpfrontGroup, onUpfrontGroupExpandedChanged,
  onRecurringGroupMoved, onRecurringItemMoved, onAddRecurringGroup, onDeleteRecurringGroup, onRecurringGroupExpandedChanged,
  onEditUpfrontGroup, onEditRecurringGroup, onUpdateRecurringVisibleGroupOrItem, onUpdateUpfrontVisibleGroupOrItem,
  onUpdateUpfrontShowChildren, onUpdateRecurringShowChildren
}) => {

  return (
    <>
      {upfrontItems.length === 0 && recurringItems.length === 0 &&
        <p>No items available for editing.</p>
      }
      {upfrontGroups.length > 0 &&
        <>
          <h3 className="mt-0">Upfront</h3>
          {mode === "flat" &&
            <LineEditorTable
                  itemRecurrence="upfront"
                  groups={upfrontGroups}
                  items={upfrontItems}
                  onGroupMoved={onUpfrontGroupMoved}
                  onItemMoved={onUpfrontItemMoved}
                  onAddGroup={onAddUpfrontGroup}
                  onDeleteGroup={onDeleteUpfrontGroup}
                  onGroupExpandedChanged={onUpfrontGroupExpandedChanged}
                  onEditGroup={onEditUpfrontGroup}
                  onUpdateVisible={onUpdateUpfrontVisibleGroupOrItem}
                  onUpdateShowChildren={onUpdateUpfrontShowChildren}
                />
              }
          </>
      }

      {recurringGroups.length > 0 &&
          <>
              <h3 className="mt-5">Recurring</h3>
              {mode === "flat" &&
                <LineEditorTable
                    itemRecurrence="recurring"
                    groups={recurringGroups}
                    items={recurringItems}
                    onGroupMoved={onRecurringGroupMoved}
                    onItemMoved={onRecurringItemMoved}
                    onAddGroup={onAddRecurringGroup}
                    onDeleteGroup={onDeleteRecurringGroup}
                    onGroupExpandedChanged={onRecurringGroupExpandedChanged}
                    onEditGroup={onEditRecurringGroup}
                    onUpdateVisible={onUpdateRecurringVisibleGroupOrItem}
                    onUpdateShowChildren={onUpdateRecurringShowChildren}
              />
              }
          </>
      }
      </>
  );
};

export default LineEditorTables;
